import React from 'react'
import Container from '@material-ui/core/Container';

import moment from 'moment';

import PoweredBySpotlioDark from "./poweredBySpotlioDark"
import PoweredBySpotlioWhite from "./poweredBySpotlioWhite"

import './index.scss';

export default ({data}) => {
    return (
        <div className="socketWrapper">
            <Container className="container" maxWidth="lg">
                <div className="poweredBySpotlio">
                    <a rel="noopener noreferrer nofollow" target="_blank" href="https://www.spotlio.com/">
                        {   
                            data && data.assets && data.assets.socket && data.assets.socket.logo ?
                            <PoweredBySpotlioDark /> : <PoweredBySpotlioWhite />
                        }
                    </a>
                </div>
                <div className="buildVersion">
                    <span>v{moment.utc(parseInt(global.appVersion)).format('YYYYMMDDHHmmss')}</span>
                </div>
            </Container>
        </div>
    )
};
